// extracted by mini-css-extract-plugin
export var heading = "heading-module--heading--hUFt0";
export var secondary = "heading-module--secondary--j1JVH";
export var center = "heading-module--center--4bj3G";